module.exports = __webpack_public_path__ + "static/img/rc.9e63b6b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/rc.jpeg
// module id = 756
// module chunks = 1